import { createAction, props } from '@ngrx/store';

export const setSelectedItem = createAction('[Selection] Set Selected Item', props<{ item: string }>());

export const setSelectedSection = createAction('[Selection] Set Selected Section', props<{ section: string }>());

export const setCallerRole = createAction('[Selection] Set Caller Role', props<{ role: string }>());

export const setUserAuthenticated = createAction('[Selection] Set User Authenticated', props<{ isAuthenticated: boolean }>());
